import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=0f8d34e4&scoped=true&"
import script from "./columns.vue?vue&type=script&lang=js&"
export * from "./columns.vue?vue&type=script&lang=js&"
import style0 from "./columns.vue?vue&type=style&index=0&id=0f8d34e4&scoped=true&lang=css&"
import style1 from "./columns.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d34e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
